import {createStore, compose, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../redux';

export default function configureStore(initialState) {
  const middlewares = [
    thunkMiddleware,
  ];

  return createStore(rootReducer, initialState, compose(
    applyMiddleware(...middlewares)
    )
  );
}



/** WEBPACK FOOTER **
 ** ./src/store/configureStore.prod.js
 **/